import { request } from "../helper/axios_helper";

export const testConnection = (
  connectionType,
  databaseName,
  hostName,
  port,
  username,
  password,
  extraParams,
  authenticationType,
) => {
  return request("POST", "/api/auth/dblib/testConnection", {
    type: connectionType,
    extraParams,
    hostname: hostName,
    port: port,
    username: username,
    password: password,
    dbName: databaseName,
    // Lets the backend run its key-file preflight before attempting a Snowflake
    // key-pair connection. Undefined for callers that do not collect it.
    authenticationType,
  });
};

export const addConnection = (
  displayName,
  connectionType,
  dbName,
  hostName,
  port,
  username,
  password,
  authenticationType,
  createDate,
  updateDate,
  extraParams,
) => {
  return request("POST", "/api/auth/dblib/addConnection", {
    displayName: displayName,
    databaseType: connectionType,
    dbName: dbName,
    hostName: hostName,
    port: port,
    username: username,
    password: password,
    authenticationType: authenticationType,
    createDate: createDate,
    updateDate: updateDate,
    // Snowflake's warehouse/role/schema and the private key path live here. Omitting it was
    // why a connection created on the DB Library page lost all of them.
    extraParams: extraParams,
  });
};

export const addDBConnection = (environmentName, dbData) => {
  return request(
    "POST",
    `/api/auth/dblib/addConnection/${environmentName}`,
    dbData,
  );
};

export const getAllConnection = () => {
  return request("GET", "/api/auth/dblib/getAllConnection");
};

export const getConnectionByName = (environmentName) => {
  return request(
    "GET",
    `/api/auth/dblib/getConnectionByEnvName/${environmentName}`,
  );
};

export const getQueryHeaders = (displayName, query) => {
  return request("POST", "/api/auth/dblib/getSqlHeader", {
    displayName: displayName,
    query: query,
  });
};

export const addMapping = (mappingData) => {
  return request("POST", "/api/auth/dblib/mapping/add", mappingData);
};

export const getMapping = (mappingName) => {
  return request("GET", `/api/auth/dblib/mapping/get/${mappingName}`);
};

export const getMappingNames = () => {
  return request("GET", "/api/auth/dblib/mapping/names");
};

export const testSql = (displayName, sql) => {
  return request("POST", "/api/auth/dblib/testQuery", {
    displayName: displayName,
    query: sql,
  });
};

export const deleteConnectionByEnvironmentNameAndDisplayName = (
  environmentName,
  displayName,
) => {
  return request(
    "DELETE",
    `/api/auth/dblib/deleteConnection/${environmentName}/${displayName}`,
  );
};

/** Supported database types, from VendorRegistry — so a new vendor needs no change here. */
export const getVendors = () => request("GET", "/api/auth/dblib/vendors");
